/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Row,
  Card,
} from 'antd';

import {
  COLORS,
  Title,
} from 'components';
import { RECEIPT_LABEL } from 'utils/env';
import { getReciboPorOrden } from 'api/recaudacion';
import { LoadingOutlined } from '@ant-design/icons';
import useQuery from 'hooks/useQuery';
import Previewer from 'components/Previewer';
import { useNavigate } from 'react-router';

const PagoExitoso = () => {
  const navigation = useNavigate();

  const [loading, setLoading] = useState(false);
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [folio] = useQuery(['referencia']);
  const [base64File, setBase64File] = useState('');
  const onCancel = () => {
    setVisiblePreview(false);
    setBase64File();
    navigation('/');
    setLoading(false);
  };

  const consultarRecibo = async () => {
    setLoading(true);
    const { base64 } = await getReciboPorOrden({ folio });
    if (base64) {
      setBase64File(base64);
    }
    setVisiblePreview(true);
    setLoading(false);
  };

  useEffect(() => {
    if (folio) {
      consultarRecibo();
    }
  }, []);

  const CardRecibo = () => (
    <Card title={(
      <Title level={3}>
        PAGO EN LINEA
      </Title>
    )}
    >
      <CardHeader>
        <Row justify="center">
          <Title level={3}>
            El Pago ha sido exitoso , se esta generando tu
            {' '}
            {RECEIPT_LABEL}
            {' '}
            <LoadingOutlined spin={loading} />
          </Title>
        </Row>
      </CardHeader>
      <br />
    </Card>
  );

  return (
    <>
      <CardRecibo />
      <Previewer
        visible={visiblePreview}
        setVisiblePreview={setVisiblePreview}
        base64={base64File}
        onCancel={onCancel}
      />
    </>
  );
};

const CardHeader = styled.div`
  background-color:${COLORS.accent};
  padding: 15px 0;
  text-align: center;
  .ant-typography {
    color: #FFFFFF !important;
  }
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

// const StyledCol = styled(Col)`
//   /* border-bottom-size: 1px; */
//   border-bottom-style: solid;
//   border-bottom-color: #f8f9fa;
// `;

//   display: inline-block;
//   font-weight: 400;
//   line-height: 1.5;
//   vertical-align: middle;
//   user-select: none;
//   padding: 0.375rem 0.75rem;
//   font-size: 1rem;
//   border-radius: 0.25rem;
//   transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
//     border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
//   font-family: inherit;
//   width: 100%;
//   max-width: 500px;
// `;

export default PagoExitoso;
